<app-nav-bar></app-nav-bar>


<div class="container-fluid" style="margin-top: 50px;">
	<div class="row">
		<div class="col-md-6">
			<img src="../../assets/images/start.gif" style="width: auto; height: 569px;float: right;">

		</div>
		<div class="col-md-6">
			<span style="
			font-size: 30px;
			font-weight: 600;
			color: #004526;
			font-family: 'Rubik', sans-serif;
			letter-spacing: .5px;
			padding: 0 68px;"
			>Start Meeting</span>
			<br>
			<br>
			<h2 style="
			font: 500 20px/32px Roboto, Helvetica Neue, sans-serif;
			 letter-spacing: .5px;
			 margin: 0 0 16px;
			 color: #736f6f;
			 padding: 0 74px;">Meeting ID and Password are generated Automatically</h2>

<div class="row">
	<div class="col-md-4">
	 <div class="form-group" style="margin-top: 22px;">
		 <span
		 style="
		 height: 70px;
		 margin-left: 74px;
		 font-size: 28px;
		 font-weight: 500;" 
		 >Meeting ID 
		 </span>
	</div>
	
	</div>
	<div class="col-md-5">
	 <div class="form-group">
	 <input type="text" name="ID" class="form-control"
	 style="
	 font-family: FontAwesome;
	 height: 59px;
	 border-radius: 10px;
	 border: 2px solid #004526;
	 padding: 0 20px;
	 font-size: 23px;
	 font-weight: 400;"
	 [(ngModel)]="model.ID"
	 placeholder="Meeting ID" disabled>
	 </div>
	</div>
	<div class="col-md-3">
	 <!-- <div class="form-group">
	 <input type="text" class="form-control"
	 style="font-family: FontAwesome;"
					 
	 placeholder="Meeting ID">
	 </div> -->
	</div>
</div>
<div class="row">
 <div class="col-md-4">
  <div class="form-group" style="margin-top: 22px;">
	  <span
	  style="
	  height: 70px;
	  margin-left: 83px;
	  font-size: 29px;
	  font-weight: 500;" 
	  >Password
	  </span>
 </div>
 
 </div>
 <div class="col-md-5">
  <div class="form-group">
  <input type="text" name="password" class="form-control"
  style="
  font-family: FontAwesome;
  height: 59px;
  border-radius: 10px;
  border: 2px solid #004526;
  padding: 0 20px;
  font-size: 23px;
  font-weight: 400;" [(ngModel)]="model.password" 
  placeholder="Password" disabled>
  </div>
 </div>
 <div class="col-md-3">
  <!-- <div class="form-group">
  <input type="text" class="form-control"
  style="font-family: FontAwesome;"
				  
  placeholder="Meeting ID">
  </div> -->
 </div>
</div>
<div class="row">
 <div class="col-12">
	 <button type="button" class="btn btn-warning btn-lg" (click)="onGenerate()" style="width:265px; margin-top: 30px; font-size: 19px; font-weight: 500; line-height: 20px; border:none;margin-left: 171px;height: 47px;color: #fff;"> Generate ID and Password </button>
 </div>
</div>
<div class="row">
 
 <div class="col-md-12">
	 
		 <img src="../../assets/images/videop.png" style="margin-left: 172px;height: 49px;">
		 &nbsp;&nbsp;&nbsp;
	 <span style="font-size: 22px;font-weight: 500;">Enable Video</span>
	 &nbsp;&nbsp;&nbsp;
	 <label class="switch">
		 <input type="checkbox" checked>
		 <span class="slider round"></span>
	   </label>

 </div>
 <!-- <div class="col-md-4"></div>
 <div class="col-md-2"></div> -->
</div>
<div class="row">
 
 <div class="col-md-12">
	 
		 <img src="../../assets/images/audiop.png" style="margin-left: 180px;height: 49px;">
		 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	 <span style="font-size: 22px;font-weight: 500;">Enable Audio</span>
	 &nbsp;&nbsp;&nbsp;&nbsp;
	 <label class="switch">
		 <input type="checkbox" checked>
		 <span class="slider round"></span>
	   </label>

 </div>
 
</div>
<div class="row">
 <div class="col-12">
	 <button type="button" class="btn btn-warning btn-lg"
	 (click)="startMeeting()" 
	 style="
	 width: 350px;
	 margin-top: 35px;
	 font-size: 19px;
	 font-weight: 500;
	 line-height: 20px;
	 border: none;
	 margin-left: 145px;
	 height: 50px;
	 color: #fff;
	 background-color: #004526;"> 
	 Start Meeting</button>
		 </div>
 </div>
 <div class="row">
	 <div class="col-12">
		 <i class="fas fa-share-alt"
		 style="font-size: 35px;
		 color: #004526;
		 margin-top: 45px;
		 margin-left: 270px;
		 cursor: pointer;"
		 ></i>
		 <span 
		 style="
		 font-size: 30px;
		 font-weight: 400;
		 cursor: pointer;
		 color: #a09c9c;
		 "> 
		 Share Link</span>
			 </div>
	 </div>
		</div>
	</div>

	<div class="loading-overlay">

		<span class="fa fa-spinner fa-spin" style="font-size:40px"></span>
	</div>

</div>

